import { makeStyles } from "@material-ui/core";

export const useElementStyles = makeStyles((theme) => ({
	gridWrapper: {
		"& .ag-cell.cell-below-min": {
			backgroundColor: " #ffa500", // Light blue with transparency
			fontWeight: "bold",
		},
		"& .ag-cell.cell-above-max": {
			backgroundColor: " #f26b6b", // Light pink with transparency
			fontWeight: "bold",
		},
		"& .ag-header-cell-label": {
			display: "flex",
			justifyContent: "center",
			alignItems: "center",
		},
	},
}));
